var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phoneIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6DD",
    d: "M16.113 26.206c-.352-.062-.704-.112-1.056-.174-1.447-.273-2.768-.844-4.013-1.589-1.95-1.167-3.61-2.669-5.145-4.332-1.56-1.689-2.98-3.489-4.1-5.5C.969 13.121.339 11.57.1 9.87c-.265-1.887-.038-3.712.918-5.4a7.7 7.7 0 0 1 1.975-2.297c.39-.298.742-.645 1.132-.943.817-.633 1.71-.608 2.44.136.415.422.805.882 1.145 1.378.629.919 1.27 1.825 1.635 2.893.377 1.092.226 2.073-.667 2.867-.453.398-.918.807-1.409 1.155-1.069.732-1.22 1.626-.817 2.78.365 1.068 1.019 1.975 1.71 2.844.906 1.142 1.887 2.222 3.02 3.14.628.51 1.295.969 2.113 1.155.716.161 1.32-.025 1.849-.51.528-.483 1.044-.98 1.585-1.44.893-.744 1.886-.769 2.905-.26.34.174.667.348.956.584 1.044.819 2.126 1.613 2.944 2.694.666.893.616 1.75-.214 2.495-.805.72-1.56 1.502-2.529 2.036a8.05 8.05 0 0 1-3.157 1.005.6.6 0 0 0-.214.05h-1.308z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phoneIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .794h24v25.412H0z"
  })))));
};
export default SvgPhoneIcon;